import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { AuthWrapper, AuthContainer, LangDropdown } from 'components/ui/index';
import classNames from 'classnames/bind';
import emailImg from 'assets/images/img-email-success.png';
import styles from '../index.less';

const cx = classNames.bind(styles);

const CheckEmail = () => {
  const actions = (
    <div className={cx('checkEmail-actions-container')}>
      <Link to="/auth/login">
        <FormattedMessage id="page.Auth.back" />
      </Link>
      <LangDropdown />
    </div>
  );

  return (
    <AuthWrapper>
      <AuthContainer
        containerClass={cx('checkEmail-container')}
        title={<FormattedMessage id="page.Auth.checkEmail" />}
        actions={actions}>
        <div className={cx('checkEmail-content')}>
          <img src={emailImg} alt="email" />
          <FormattedMessage id="page.Auth.checkEmailToReset.firstParagraph">
            {text => (
              <span className={cx('checkEmail-content-text')}>{text}</span>
            )}
          </FormattedMessage>
          <FormattedMessage id="page.Auth.checkEmailToReset.secondParagraph">
            {text => (
              <span className={cx('checkEmail-content-text')}>{text}</span>
            )}
          </FormattedMessage>
        </div>
      </AuthContainer>
    </AuthWrapper>
  );
};

export default CheckEmail;



// WEBPACK FOOTER //
// ./src/views/Auth/CheckEmail/container/index.jsx